module.exports = __webpack_public_path__ + "img/co2_outline_by.bfb68f6b.svg";